import { useTranslation } from 'react-i18next';

const DefaultRoleBadge = () => {
  const { t } = useTranslation();

  return (
    <span className="bg-primaryComp-50 rounded-2xl px-1.5 py-0.5 text-white text-size-xs">
      {t('workspaces.default_role')}
    </span>
  );
};

export default DefaultRoleBadge;
